import { render, staticRenderFns } from "./rewardItem.vue?vue&type=template&id=02f84600&scoped=true&"
import script from "./rewardItem.vue?vue&type=script&lang=js&"
export * from "./rewardItem.vue?vue&type=script&lang=js&"
import style0 from "./rewardItem.vue?vue&type=style&index=0&id=02f84600&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f84600",
  null
  
)

component.options.__file = "rewardItem.vue"
export default component.exports